export default "__VITE_ASSET__CejzE89g__"